/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Faq_Photos_AInputs */

const en_road_dude_faq_photos_a = /** @type {(inputs: Road_Dude_Faq_Photos_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with one clear reference image of your subject. For a person, use a front or three-quarter angle with the face unobstructed. For a pet, keep the eyes, ears, and markings visible.`)
};

const zh_road_dude_faq_photos_a = /** @type {(inputs: Road_Dude_Faq_Photos_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一张清晰参考图就可以开始。人物建议用正面或四分之三侧脸，避免遮挡。宠物照片最好能看清眼睛、耳朵和毛色花纹。`)
};

/**
* | output |
* | --- |
* | "Start with one clear reference image of your subject. For a person, use a front or three-quarter angle with the face unobstructed. For a pet, keep the eyes, ..." |
*
* @param {Road_Dude_Faq_Photos_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_faq_photos_a = /** @type {((inputs?: Road_Dude_Faq_Photos_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Faq_Photos_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_faq_photos_a(inputs)
	return zh_road_dude_faq_photos_a(inputs)
});
export { road_dude_faq_photos_a as "road_dude.faq.photos.a" }